import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { useDispatch } from "react-redux";
import AppRoutes from "./routes/AppRoutes";
import ToastManager from "./components/newComp/ToastManager";
import { initializeAuth } from "./store/slices/authSlice";
import './app.css';


function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(initializeAuth());
  }, [dispatch]);

  return (
    <Router>
      <ToastManager />
      <AppRoutes />
    </Router>
  );
}

export default App;
